import PATHS from '../constants';

function fetchSlider() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.HOME_SLIDER, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchSlider;